import { render, staticRenderFns } from "./EmailTagsInput.vue?vue&type=template&id=c597eab6&scoped=true&"
import script from "./EmailTagsInput.vue?vue&type=script&lang=js&"
export * from "./EmailTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./EmailTagsInput.vue?vue&type=style&index=0&id=c597eab6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c597eab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c597eab6')) {
      api.createRecord('c597eab6', component.options)
    } else {
      api.reload('c597eab6', component.options)
    }
    module.hot.accept("./EmailTagsInput.vue?vue&type=template&id=c597eab6&scoped=true&", function () {
      api.rerender('c597eab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailTagsInput.vue"
export default component.exports